import React, { useCallback, useEffect, useRef, useState } from 'react'
import { TaskBoard } from './components/TaskBoard'
import { useApp, useCommon, useTask, useUser } from 'hooks';
import { EModeVideProject, ETaskActions } from 'types';
import { TaskList } from './components/TaskList';
import { TaskGantt } from './components/TaskGantt';
import { BottomModal, CenteredModal, LargeModal } from 'components';
import TaskForm from './TaskForm';
import Attachment from './components/attachment/Attachment';

export default function Tasks() {
    const prevRef = useRef({ path: '' }).current;
    const { defaultProject } = useUser();
    const [isFetch, setIsFetch] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const { trans, taskDetail, onUpdateParams, taskDetailIsFetch } = useApp();
    const { fetchData: fetchDataTasks, attachmentTask, detach, delTask, updateTask } = useTask();
    const boardState = useCommon(state => state.boardState);
    const taskState = useCommon(state => state.actionsTaskState);
    const { setActionsTaskState } = useCommon()
    const [actPopup, setActPopup] = useState('');
    const onClose = (isf = false) => {
        setActPopup(null);
        if (isf) {
            setIsFetch(s => ++s);
            onUpdateParams({ taskDetailIsFetch: !taskDetailIsFetch })
        }
        setActionsTaskState({ method: null })
    }

    const { data: dataTasks = null, } = fetchDataTasks(defaultProject?.id, currentPage, isFetch);

    useEffect(() => {
        if (boardState) {
            setIsFetch(s => ++s);
            // onUpdateParams({ taskDetailIsFetch: !taskDetailIsFetch })
        }
    }, [boardState])

    const onConfirmAttachment = ({ files }: { files: FileList }) => {
        console.log("🚀 ~ onConfirmAttachment ~ files:", files)
        if (files?.length) {
            attachmentTask.mutate({ project_id: defaultProject?.id, id: taskDetail?.id, files }, {
                onSuccess: () => {
                    onClose(true);
                }
            });
            return;
        }
        onClose();
    }

    const onConfirmDelTask = () => {
        delTask.mutate({ project_id: defaultProject?.id, id: taskDetail?.id }, {
            onSuccess: () => {
                onUpdateParams({ taskDetail: null })
                onClose(true);
            }
        });
        prevRef.path = '';
    }

    const onConfirmDetach = () => {
        detach.mutate({ project_id: defaultProject?.id, id: taskDetail?.id, path: prevRef.path }, {
            onSuccess: () => {
                onClose(true);
            }
        });
        prevRef.path = '';
    }

    useEffect(() => {
        taskState?.['method'] && handleActions(taskState?.['method'])
        console.log("🚀 ~ Tasks ~ taskState:", taskState)
    }, [taskState])

    const handleActions = (act, opts: any = {}) => {
        if (opts?.['path']) {
            prevRef.path = opts?.['path']
        }
        // attachment
        switch (act) {
            case ETaskActions.OPEN:
            case ETaskActions.CLOSED:
            case ETaskActions.UPDATE:
                updateTask.mutate(opts, {
                    onSuccess: () => {
                        onClose(true);
                    }
                })
                break;
            case ETaskActions.ADD:
                onUpdateParams({ taskDetail: null });
                setActPopup(act);
                break;
            case ETaskActions.EDIT:
            case ETaskActions.ATTACHMENT:
            case ETaskActions.DETACH:
            case ETaskActions.DELETE:
                setActPopup(act)
                break;
            case ETaskActions.PAGINATE:
                setCurrentPage(opts?.['page'] ?? 1)
                break;
            default:
                break;
        }
    }

    const renderContent = useCallback(() => {
        switch (boardState) {
            case EModeVideProject.list:
                return dataTasks ? (
                    <TaskList
                        projectId={defaultProject?.id}
                        currentPage={currentPage}
                        dataTasks={dataTasks}
                        isFetch={isFetch}
                        onAction={handleActions}
                    />) : <></>;
            case EModeVideProject.kanban:
                return (
                    <TaskBoard
                        projectId={defaultProject?.id}
                        // currentPage={currentPage}
                        dataTasks={dataTasks}
                        // isFetch={isFetch}
                        onAction={handleActions}
                    />
                );
            case EModeVideProject.gantt:
                return (
                    <TaskGantt
                        dataTasks={dataTasks}
                        onAction={handleActions}
                    />
                );
            default:
                break;
        }
    }, [boardState, dataTasks, isFetch])

    return defaultProject ? (
        <div className=' bg-gray-50 '>
            {defaultProject ? <>
                {/* <FilterBar onAction={handleActions} /> */}
                {renderContent()}
                {['add', 'edit'].includes(actPopup) && <BottomModal title={`${trans(actPopup)} nhiệm vụ`} onClose={onClose} >
                    <TaskForm onClose={onClose} onConfirm={() => onClose(true)} />
                </BottomModal>}
                {[`${ETaskActions.ATTACHMENT}`].includes(actPopup) && <LargeModal title={`${trans(actPopup)}`} onClose={onClose} >
                    <Attachment onClose={onClose} onConfirm={e => {
                        onConfirmAttachment(e)
                    }} />
                </LargeModal>}
                {[`${ETaskActions.DETACH}`].includes(actPopup) &&
                    <CenteredModal
                        title={`${trans('delete')} file`}
                        type={'delete'}
                        description='Bạn có chắc muốn xoá file này không?'
                        onClose={onClose}
                        onConfirm={onConfirmDetach} />
                }
                {[`${ETaskActions.DELETE}`].includes(actPopup) &&
                    <CenteredModal
                        title={`${trans('delete')} nhiệm vụ`}
                        type={'delete'}
                        description='Bạn có chắc muốn xoá nhiệm vụ này không?'
                        onClose={onClose}
                        onConfirm={onConfirmDelTask} />
                }
            </> : <></>}
        </div>
    ) : <></>;
}
